// removed by extract-text-webpack-plugin
module.exports = {"pageLevelSpinnerContainer":"CommonSpinner__pageLevelSpinnerContainer","page-level-spinner-wrapper":"CommonSpinner__page-level-spinner-wrapper","pageLevelSpinnerWrapper":"CommonSpinner__page-level-spinner-wrapper","page-level-gray-area":"CommonSpinner__page-level-gray-area","pageLevelGrayArea":"CommonSpinner__page-level-gray-area"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CommonSpinner/CommonSpinner.scss
// module id = 1484
// module chunks = 8